// extracted by mini-css-extract-plugin
export default {"box":"cancellationDetailPage_box__dAN80","box__order__detail":"cancellationDetailPage_box__order__detail__QpZjL"};